import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsWidgetsRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsWidgetsRouterService implements SettingsWidgetsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDashboardSettings({ id }: { id: string }) {
    this.history.push(
      `/${this.role.get()}/${
        modules.settings.basename
      }/company/${id}/dashboard`,
    );
  }

  goToBannerEdit({ id, widgetId }: { id: string; widgetId: string }) {
    this.history.push(
      `/${this.role.get()}/${
        modules.settings.basename
      }/company/${id}/dashboard/${widgetId}/banner`,
    );
  }

  goToBannerCreate({ id, side }: { id: string; side: 'account' | 'company' }) {
    this.history.push(
      `/${this.role.get()}/${
        modules.settings.basename
      }/${side}/${id}/dashboard/banner/create`,
    );
  }

  goToCompanyDashboardPartitionsSettings(id: string, widgetId: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/dashboard-settings/partitions-company/${widgetId}`,
    );
  }

  goToCompanyDashboardPartitionsEmployeeSettings(id: string, widgetId: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.company.basename
      }/${id}/dashboard-settings/partitions-employee/${widgetId}`,
    );
  }
}
